if (!customElements.get('product-feature-stack')) {
  customElements.define(
    'product-feature-stack',
    class ProductFeatureStack extends HTMLElement {
      constructor() {
        super();
        this.frame = null;
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleImageLoad = this.handleImageLoad.bind(this);
      }

      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.product-feature-stack__card'));
        if (!this.cards.length) return;

        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.productImages = this.cards
          .map((card) => card.querySelector('.product-feature-stack__product-image'))
          .filter(Boolean);

        this.productImages.forEach((image) => {
          image.addEventListener('load', this.handleImageLoad);
        });

        window.addEventListener('resize', this.handleUpdate);

        if (!this.prefersReducedMotion) {
          window.addEventListener('scroll', this.handleUpdate, { passive: true });
        }

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.handleUpdate);
          this.resizeObserver.observe(this);

          this.cards.forEach((card) => {
            this.resizeObserver.observe(card);

            const image = card.querySelector('.product-feature-stack__product-image');
            if (image) this.resizeObserver.observe(image);
          });
        }

        this.handleUpdate();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleUpdate);
        window.removeEventListener('resize', this.handleUpdate);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }

        if (this.productImages) {
          this.productImages.forEach((image) => {
            image.removeEventListener('load', this.handleImageLoad);
          });
        }

        if (this.frame) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
        }
      }

      handleImageLoad() {
        this.handleUpdate();
      }

      handleUpdate() {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateCards();
        });
      }

      updateCards() {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const isDesktop = window.innerWidth >= 990;
        const revealWindow = 0.20;
        const revealDistance = Math.max(1, viewportHeight * revealWindow);
        const maxOverlayOpacity = 0.5;
        const baseProductScale = isDesktop ? 0.94 : 1;
        const maxProductScaleDelta = isDesktop ? 0.06 : 0;

        this.cards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          const clampedTop = clamp(0, rect.top, viewportHeight);
          const revealProgress = 1 - clamp(0, clampedTop / revealDistance, 1);
          const overlayOpacity = this.prefersReducedMotion
            ? 0
            : clamp(0, clampedTop / revealDistance, 1) * maxOverlayOpacity;
          const productScale = this.prefersReducedMotion
            ? 1
            : baseProductScale + revealProgress * maxProductScaleDelta;

          card.style.setProperty('--product-feature-overlay-opacity', `${overlayOpacity}`);
          card.style.setProperty('--product-feature-product-scale', `${productScale}`);

          const productImage = card.querySelector('.product-feature-stack__product-image');
          if (!productImage) return;

          if (isDesktop) {
            card.style.setProperty('--product-feature-mobile-product-offset', '0px');
            return;
          }

          const productImageHeight = productImage.getBoundingClientRect().height;
          const productOffset = Math.max(0, Math.round(productImageHeight / 2));
          card.style.setProperty('--product-feature-mobile-product-offset', `${productOffset}px`);
        });
      }
    }
  );
}

function clamp(min, value, max) {
  return Math.min(Math.max(value, min), max);
}